<style>

</style>
<template>
  <div class="chung-search">
    <search-base>
      <template v-slot:intro>
        <p class="center-txt">Search across the library's digital and physical holdings for Chung Collection archival
          materials, artifacts, and publications.</p>
      </template>
      <template v-slot:search-scope="slotProps">
        <search-scope :scope="slotProps.scope" :queryObj="slotProps.queryObj"></search-scope>
      </template>
      <template v-slot:results-slot="slotProps">
        <chung-results v-for="r in slotProps.results" :key="r._id" :r="r"></chung-results>
      </template>
    </search-base>

  </div>
</template>

<script>
  // import base search component from lit-discovery module
  import searchBase from 'lit-discovery/vue/search-base.vue';
  import chungResults from './components/_chung-results.vue';
  import searchScope from './components/_search-scope.vue';
  
  export default {
    setup() {
    },
    components: {
      "search-base" : searchBase,
      "chung-results" : chungResults,
      "search-scope" : searchScope,
    },
    data() {
      return {
        resultsView : "chung-results"
      }
    }

  }
</script>